import { render } from "./reset-password.vue?vue&type=template&id=07e63b03"
import script from "./reset-password.vue?vue&type=script&lang=ts"
export * from "./reset-password.vue?vue&type=script&lang=ts"
script.render = render

export default script